'use client'

import { Tab } from '@macarongfactory/web-ui'

import {
  MODOOCAR_CODE,
  useModoocarImpression,
  useModoocarTracking,
} from '../_features/modoocar'

export interface ISectionTabItem {
  id: string
  label: string
}

interface ISectionTabsProps {
  items: ISectionTabItem[]
  activeId: string
  onSelect: (id: string) => void
}

const SectionTabs = ({ items, activeId, onSelect }: ISectionTabsProps) => {
  const { sectionShow, itemClick } = useModoocarTracking()
  const sectionRef = useModoocarImpression<HTMLElement>(() =>
    sectionShow(MODOOCAR_CODE.TAB_NAV, '섹션 네비게이션')
  )

  return (
    <nav
      ref={sectionRef}
      className='sticky top-[var(--mc-tab-top,48px)] z-20 bg-background-surface-default lg:top-[65px]'
      aria-label='섹션 이동'
    >
      <Tab scrollable divider='horizontal'>
        {items.map(item => (
          <Tab.TabItem
            key={item.id}
            text={item.label}
            selected={item.id === activeId}
            clickable={() => {
              itemClick(MODOOCAR_CODE.TAB_NAV, 'tab', item.label)
              onSelect(item.id)
            }}
          />
        ))}
      </Tab>
    </nav>
  )
}

export default SectionTabs
